module.exports = __webpack_public_path__ + "static/media/icon-coin-clients-bottom.743e5bd4.png";